import React from "react";

export default function CardBasic({
  i,
  data,
  children,
  title,
  isDisable,
  enActionDelete,
  enActionEdit,
  deleteFunction,
  editFunction,
  onClickCustomFunction,
  customButton,
  information,
}) {
  return (
    <div
      className="w-full relative bg-white shadow-sm rounded-lg border border-gray-200"
      onClick={onClickCustomFunction}
    >
      <div className="px-5 py-3 border-b border-gray-200">
        <div className="flex justify-between items-center">
          <div className="font-semibold text-gray-700 text-lg truncate">
            {title}
          </div>
          <div className="flex space-x-2">
            {customButton && customButton}
            {enActionEdit && (
              <button
                className={`btn-sm ${
                  isDisable ? "bg-gray-400" : "bg-[#4CA6F8]"
                } text-white`}
                disabled={isDisable}
                onClick={() => editFunction(data)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                  />
                </svg>
              </button>
            )}
            {enActionDelete && (
              <button
                className={`btn-sm ${
                  isDisable ? "bg-gray-400" : "bg-red-400"
                } text-white`}
                disabled={isDisable}
                onClick={() => {
                  deleteFunction(i, data);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                  />
                </svg>
              </button>
            )}
          </div>
        </div>
        {/* Information */}
        {information && information}
      </div>
      {children}
    </div>
  );
}
